//Constant
export const USER_LOADING = "USER_LOADING";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
